import {useCrmCouponTokenParam} from '@aboutyou/logic-components';
import {Redirect, useParams} from '@aboutyou/router';
import React from 'react';
import {CouponActivationPage} from './CouponActivationPage.eager';
import {CouponLandingPage} from './CouponLandingPage.eager';

export const CouponLandingPageSwitch: React.FC = () => {
  const couponToken = useCrmCouponTokenParam();
  const {promotionId} = useParams();

  if (promotionId) {
    return <CouponLandingPage />;
  }

  if (couponToken) {
    return <CouponActivationPage />;
  }

  return <Redirect to="404" />;
};
